export default "__VITE_ASSET__CduzgjeH__"